import axios from "axios";
import { Notification, MessageBox, Message, Loading } from "element-ui";

let baseConfig;
if (process.env.NODE_ENV == "production") {
    baseConfig = {
        baseURL: 'http://api.huahuip.com/v1',
        // baseURL: 'v1',
        timeout: 10000, // Timeout
        withCredentials: true, // Check cross-site Access-Control
    };
} else {
    baseConfig = {
        baseURL: "v1",
        timeout: 10000, // Timeout
        withCredentials: true, // Check cross-site Access-Control
    };
}

// axios.defaults.headers["Content-Type"] = "application/json;";
// 创建axios实例
const service = axios.create(baseConfig);
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    // const isToken = (config.headers || {}).isToken === false;
    // if (getToken() && !isToken) {
    //   config.headers["accessToken"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    return res.data;
  },
  (error) => {
    console.log("err" + error);
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/index.js